import styled from 'styled-components';

export const MainContentContainer = styled.main`
  display: flex;
  height: 100%;
  /* gap: ${({ theme }) => theme.spacing.xl}; */
  /* padding: ${({ theme }) => theme.spacing.m}; */
  h2 {
    margin-bottom: ${({ theme }) => theme.spacing.xl};
  }
  @media screen and (max-width: 1070px) {
    gap: ${({ theme }) => theme.spacing.s};
  }
  @media screen and (max-width: 768px) {
    padding: ${({ theme }) => theme.spacing.s};
  }
  @media screen and (max-width: 480px) {
    padding: 0;
  }
`;

export const MainSection = styled.section`
  overflow-x: hidden;
  width: 80%;
  height: 100vh;
  padding: ${({ theme }) => theme.spacing.xxl};
  height: 100%;
  min-height: 100vh;
  /* background: radial-gradient(
      circle at top right,
      rgba(255, 210, 66, 0.08),
      transparent 24%
    ),
    radial-gradient(
      circle at bottom left,
      rgba(230, 139, 7, 0.05),
      transparent 28%
    ),
    linear-gradient(180deg, #ffffff 0%, #fafafa 100%); */
  /* border: 2px solid orange; */
  @media screen and (max-width: 1070px) {
    width: 70%;
    padding: ${({ theme }) => theme.spacing.l};
  }
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;
